// extracted by mini-css-extract-plugin
module.exports = {"order":"order_order__2xpfE","label":"order_label__3nVFm","select":"order_select__3bVm6"};